import React, { useState } from "react";
import clsx from "clsx";
import { v4 as uuidv4 } from "uuid";
import { BaseTypography, LinearTabs } from "src/components/common";
import { makeStyles } from "@material-ui/core/styles";
import { IGuestInfo } from "src/api/base/Guest/types";
import ReactPlayer from "react-player";
import { Link } from "@material-ui/core";
import { Rating } from "@material-ui/lab";

import arrowImg from './arrow.png';

enum TabValues {
  Resource,
  Mediatrainingfeedback,
}

const tabs = [
  { label: "Resource", value: TabValues.Resource },
  { label: "Media training feedback", value: TabValues.Mediatrainingfeedback },
];

const getListOfMedia = (width: string) => {
  return {
    display: "grid",
    gridTemplateColumns: `repeat(auto-fill, ${width})`,
    gridGap: "20px",
  };
};
const useStyles = makeStyles((theme) => ({
  listOfImages: getListOfMedia("190px"),
  listOfVideos: getListOfMedia("250px"),
  listOfLinks: {
    margin: "20px 0",
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  },
  link: {
    color: theme.palette.primary.main,
  },
  video: {
    borderRadius: "8px",
    overflow: "hidden",
    position: "relative",
  },
}));

const Video: React.FC<{ url: string; comeFrom: string }> = (props) => {
  const { url, comeFrom } = props;

  const [canPlay, setCanPlay] = useState<boolean>(ReactPlayer.canPlay(url));

  const styles = useStyles();

  /* if (url.includes('vimeo.com')) {
	  return (
		<>
		  <Link style={{ width: '100%' }} href={url} target="_blank" rel="noreferrer">
			{url}
		  </Link>
		</>
	  );
	} */

  return (
    !canPlay && (
      <>
        <Link
          style={{ width: "100%" }}
          href={url}
          target="_blank"
          rel="noreferrer"
        >
          {url}
        </Link>
        <br />
      </>
    )
  );
};

type PTabMenu = {
  mediatrainingfeedback: IGuestInfo["Mediatrainingfeedback"];
  resource: IGuestInfo["resource"];
  className?: any;
  comeFrom?: string;
};
const checkIsYoutubeLink = (link: string) => link.includes("youtube.com");

export const TabMenu: React.FC<PTabMenu> = (props) => {
  const { Mediatrainingfeedback, resource, className, comeFrom } = props;
  const [currentTab, setCurrentTab] = useState(TabValues.Resource);
  const classes = useStyles();
  
  console.log(Mediatrainingfeedback);
  /* eslint no-underscore-dangle: 0 */
  const before_rating = Mediatrainingfeedback[0]?.Self_x002d_rating_x0020__x002d__ ?? 0;
  const after_rating = Mediatrainingfeedback[0]?.Self_x002d_rating_x0020__x002d__0 ?? 0;
  
  const ratingMap: { [key: string]: number } = {
	  'Excellent': 5,
	  'Good': 4,
	  'Adequate': 3,
	  'Room for improvement': 2,
	  'Poor': 1,
  };

  const pwn_rating = ratingMap[Mediatrainingfeedback[0]?.Elements_x002d_PWN?.trim()] ?? 0;
  const facilitator_rating = ratingMap[Mediatrainingfeedback[0]?.Elements_x002d_Facilitator?.trim()] ?? 0;
  const studio_rating = ratingMap[Mediatrainingfeedback[0]?.Elements_x002d_Studio?.trim()] ?? 0;	

  return (
    <div className={clsx(className)}>
      <LinearTabs tabs={tabs} value={currentTab} onTabClick={setCurrentTab} />

      <div className={classes.body}>
        {currentTab === TabValues.Resource && (
          <div>
            {/* {resource && resource.length > 0 ? ( */}

            <div className="key-information-container">
			  {resource?.training_certificate && (
				  <>
					  <div className="key-information-contain">
						<div
						  style={{ marginTop: "16px" }}
						  className="key-information-title"
						>
						  Training certificate
						</div>

						<a
						  href={resource?.training_certificate}
						  target="_blank"
						  style={{
							fontWeight: 400,
							fontSize: "16px",
							lineHeight: "24px",
							color: "#4A9EDB",
							display: "inline-block",
							textDecoration: "none",
						  }}
						  rel="noreferrer"
						>
						  {resource?.training_certificate}
						</a>
					  </div>
				  </>
			  )}
			  {resource?.onedrive_link && (
				  <>
					  <div className="key-information-contain">
						<div
						  style={{ marginTop: "16px" }}
						  className="key-information-title"
						>
						  Training videos
						</div>

						<a
						  href={resource?.onedrive_link}
						  target="_blank"
						  style={{
							fontWeight: 400,
							fontSize: "16px",
							lineHeight: "24px",
							color: "#4A9EDB",
							display: "inline-block",
							textDecoration: "none",
						  }}
						  rel="noreferrer"
						>
						  {resource?.onedrive_link}
						</a>
					  </div>
				  </>
			  )}
			  {resource?.background_briefings_story && (
				  <>
					  <div className="key-information-contain">
						<div
						  style={{ marginTop: "16px" }}
						  className="key-information-title"
						>
						  Background briefing
						</div>

						<a
						  href={resource?.background_briefings_story}
						  target="_blank"
						  style={{
							fontWeight: 400,
							fontSize: "16px",
							lineHeight: "24px",
							color: "#4A9EDB",
							display: "inline-block",
							textDecoration: "none",
						  }}
						  rel="noreferrer"
						>
						  {resource?.background_briefings_story}
						</a>
					  </div>
				  </>
			  )}
            </div>
          </div>
        )}

        {currentTab === TabValues.Mediatrainingfeedback && (
          <>
            {Mediatrainingfeedback && Mediatrainingfeedback.length > 0 ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{ marginTop: "16px" }}
                    className="key-information-title"
                  >
                    Self-assessment:
                  </div>
                  <div className="mediaSelfAssessment">
                    <div className="">
                      <div className="key-information-title">
                        Media skills before
                      </div>
                      <div className="mediaSelfcount">
                        <span className="mediaSelfcountspan"> {before_rating}</span>/10
                      </div>
                    </div>

                    <div className=""> <img src={arrowImg} alt="Arrow" /> </div>

                    <div className="">
                      <div className="key-information-title">
                        Media skills after
                      </div>
                      <div className="mediaSelfcount">
                        <span className="mediaSelfcountspan spn_blue"> {after_rating}</span>
                        /10
                      </div>
                    </div>
                  </div>
                </div>
                {/*  */}
                <div className="mediaSelfsecContainer">
                  <div className="mediaSelfsecContainer0 mediacontainer-left">
                    <div className="">
                      <div className="key-information-title">
                        Program duration{" "}
                      </div>
                      <div className="key-information-text">{Mediatrainingfeedback[0].Program_x0020_duration}</div>
                    </div>
                    <div className="">
                      <div className="key-information-title">Expectations</div>
                      <div className="key-information-text">
					  {Mediatrainingfeedback[0].Expectations}
                      </div>
                    </div>
                    <div className="">
                      <div className="key-information-title">
                        Recommendation
                      </div>
                      <div className="key-information-text">{Mediatrainingfeedback[0].Recommendation}</div>
                    </div>
                  </div>
                  <div className="mediaSelfsecContainer0 mediacontainer-right">
                    <div className="key-information-title">
                      Experience ratings
                    </div>
                    <div className="rating-grid">
                      <div className="key-information-text">Book/Notes</div>
                      <Rating
                        name="rating"
                        size="medium"
                        value={pwn_rating}
                        precision={1}
                        readOnly
                      />
                    </div>
                    <div className="rating-grid">
                      <div className="key-information-text">Facilitator</div>
                      <Rating
                        name="rating"
                        size="medium"
                        value={facilitator_rating}
                        precision={1}
                        readOnly
                      />
                    </div>
                    <div className="rating-grid">
                      <div className="key-information-text">Studio</div>
                      <Rating
                        name="rating"
                        size="medium"
                        value={studio_rating}
                        precision={1}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
                {/*  */}
                {/*  */}
                <div className="mediafullwidthcontainer">
                  <div className="">
                    <div className="key-information-title">
                      What guest liked:
                    </div>
                    <div className="key-information-text">
                      {Mediatrainingfeedback[0].What_x0020_I_x0020_liked}
                    </div>
                  </div>
                  <div className="">
                    <div className="key-information-title">
                      Areas for improvement:
                    </div>
                    <div className="key-information-text">
                      {Mediatrainingfeedback[0].Areas_x0020_for_x0020_improvemen}
                    </div>
                  </div>
                </div>
                {/*  */}
              </div>
            ) : (
              <p>No content found</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};
